<template>
  <section>
    <div class="col-sm-12 col-md-12 form-group pt-3 mt-2">
      <div class="col-sm-12 col-md-12 form-group text-left pb-0 mb-0">
        <p
          class="text-center text-uppercase"
          style="font-size: 1rem; line-height: 24px"
          :style="template.secondaryTheme ? 'color:white;' : ''"
        >
          Recupere sua senha
        </p>
      </div>

      <!-- Error -->
      <div v-if="errors.length" class="col form-group">
        <div class="mb-1 mt-2 p-2 c-errors">
          <p class="fontMenor mb-2" :style="template.secondaryTheme ? 'color: white;' : ''">
            <strong>{{ errors[0].title }}</strong>

            <br />

            {{ errors[0].msg }}
          </p>
        </div>
      </div>

      <p
        class="my-5 col fontMenor text-center"
        style="word-break: break-word"
        :style="template.secondaryTheme ? 'color:white;' : ''"
      >
        <small>
          Insira seu

          <span v-if="config.loginType == 4">email</span>
          <span v-else>CPF</span>

          para recuperar a sua {{ template.secondaryTheme ? 'senha' : 'conta' }}.
        </small>
      </p>

      <div class="col form-group mt-5 mb-4">
        <input
          v-if="config.loginType == 4"
          v-model="userLogin"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : 'c-input'"
          placeholder="E-mail"
          :style="{ borderColor: template.inputBorderColor }"
          type="email"
          @keyup="errors = []"
        />

        <input
          v-else
          v-model="userLogin"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : 'c-input'"
          placeholder="CPF"
          :style="{ borderColor: template.inputBorderColor }"
          type="email"
          @keyup="errors = []"
        />
      </div>

      <!-- Buttons -->
      <div class="col-sm-12 col-md-12 form-group mt-2 pt-3">
        <button
          class="btn btn-block shadow-sm text-uppercase btnStock btn"
          :style="primaryBtnStyle"
          type="submit"
          @click="recuperaEmail"
        >
          Recuperar
        </button>

        <button
          class="btn btn-block text-uppercase shadow-sm btnStock btn mt-3"
          :style="template.secondaryTheme ? secondaryBtnStyleTheme : secondaryBtnStyle"
          @click="$router.push(sso ? '/authorize' : '/login')"
        >
          <i class="fa fa-caret-left" />

          Voltar
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/* Services */
import { loginFB } from '../../services/ServFB.js'

/* State */
import { mapState, mapGetters } from 'vuex'

const lFB = new loginFB()

export default {
  name: 'Inicio',
  data: () => ({
    errors: [],
    userLogin: '',
  }),
  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle', 'secondaryBtnStyleTheme']),
    ...mapState(['config', 'template', 'subdomain', 'sso']),
  },
  mounted() {
    document.getElementById('email').focus()
  },
  methods: {
    recuperaEmail() {
      if (this.userLogin) {
        this.postEmail()
      } else {
        this.errors.push({
          type: 'email',
          title: 'Dados incompletos',
          msg: `Por favor preencha o campo abaixo.`,
        })
      }
    },
    postEmail() {
      const data = {
        ownerID: parseInt(this.config.ownerId),
        sysId: parseInt(this.config.systemID),
        login: this.userLogin,
      }

      lFB
        .recoverPwd(data)
        .then(res => {
          this.$store.commit('setRecoveryDestination', res)
          this.$emit('component', 'msg-email')
        })
        .catch(err => {
          this.errors.push({
            type: 'post',
            title: 'Erro ao enviar solicitação',
            msg: `${err}`,
          })
        })
    },
  },
}
</script>
